import {Component, EventEmitter, HostListener, inject, Input, OnInit, Output} from "@angular/core";
import { CommonModule } from "@angular/common";
import {faChevronLeft, faChevronRight, faTimes} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {StudentExam} from "../../../dashboard/feature/studentDashboard/studentDashboard.component";
import {Router} from "@angular/router";
import * as querystring from "node:querystring";

interface CalendarDay {
  dayNumber: number;
  isCurrentMonth: boolean;
  date: Date;
  toggled: boolean;
}

@Component({
  selector: 'interactive-calendar',
  imports: [CommonModule, FontAwesomeModule, FormsModule],
  templateUrl: './interactive-calendar.component.html',
})
export class InteractiveCalendarComponent implements OnInit {
  @Input('startDate') startDate: Date | undefined;
  @Input('endDate') endDate: Date | undefined;
  @Output() startDateChange: EventEmitter<Date | undefined> = new EventEmitter();
  @Output() endDateChange: EventEmitter<Date | undefined> = new EventEmitter();
  date = new Date();
  router = inject(Router);
  calendarDays: CalendarDay[][] = [[],[],[],[],[],[]]

  ngOnInit(): void {
    this.fillCalendar()
  }

  ngOnChanges(): void {
    this.fillCalendar()
  }

  fillCalendar() {
    this.calendarDays = [[],[],[],[],[],[]]
    const firstDayOfCurrentMonth = new Date(this.date.getFullYear(), this.date.getMonth(), 1).getDay();
    const currentMonthsMax = new Date(this.date.getFullYear(), this.date.getMonth()+1, 0).getDate();
    const lastMonthDate = new Date(this.date.getFullYear(), this.date.getMonth(), 0).getDate();

    let lastMonthStartDate = lastMonthDate - firstDayOfCurrentMonth + 1

    // Start the count at 2 since we set the first day of the month at 1
    let currentMonthDateCount = 2

    this.calendarDays[0][firstDayOfCurrentMonth] = {dayNumber: 1, isCurrentMonth: true, toggled: false, date: new Date(this.date.getFullYear(), this.date.getMonth(), 1)};

    // Front fill first week of calendar with previous months days
    for (let i = 0; i < firstDayOfCurrentMonth; i++) {
      if(this.date.getMonth() === 0) {
        this.calendarDays[0][i] = {dayNumber: lastMonthStartDate, isCurrentMonth: false, toggled: false, date: new Date(this.date.getFullYear()-1, 11, lastMonthStartDate)};
      } else {
        this.calendarDays[0][i] = {dayNumber: lastMonthStartDate, isCurrentMonth: false, toggled: false, date: new Date(this.date.getFullYear(), this.date.getMonth()-1, lastMonthStartDate)};
      }
      lastMonthStartDate += 1
    }

    // Fill first week
    for(let i = firstDayOfCurrentMonth + 1; i < 7; i++) {
      this.calendarDays[0][i] = {dayNumber: currentMonthDateCount, isCurrentMonth: true, toggled: false, date: new Date(this.date.getFullYear(), this.date.getMonth(), currentMonthDateCount)}
      currentMonthDateCount += 1
    }

    let backfillCount = 1
    // Fill rest of the weeks until we hit the end of current month then start backfilling the rest of the calendar
    for(let week = 1; week < this.calendarDays.length; week++ ) {
      for(let i = 0; i < 7; i++) {
        if(currentMonthDateCount < currentMonthsMax + 1) {
          this.calendarDays[week][i] = {dayNumber: currentMonthDateCount, isCurrentMonth: true, toggled: false, date: new Date(this.date.getFullYear(), this.date.getMonth(), currentMonthDateCount)}
          currentMonthDateCount += 1
        } else {
          // Check if the next month is January of next year
          if(this.date.getMonth() + 1 > 11) {
            this.calendarDays[week][i] = {dayNumber: backfillCount, isCurrentMonth: false, toggled: false, date: new Date(this.date.getFullYear() + 1, 0, backfillCount)}
          } else {
            this.calendarDays[week][i] = {dayNumber: backfillCount, isCurrentMonth: false, toggled: false, date: new Date(this.date.getFullYear(), this.date.getMonth() + 1, backfillCount)}
          }
          backfillCount += 1
        }
      }
    }
  }

  toggleDate(date: Date) {
    // TODO need to either set or remove a start/end date and
    if(this.isSameDay(this.startDate, date)) {
      this.startDate = undefined;
    } else if(this.isSameDay(this.endDate, date)) {
      this.endDate = undefined;
    } else if(this.startDate === undefined || date < this.startDate) {
      this.startDate = date;
    } else {
      this.endDate = date;
    }
    this.startDateChange.emit(this.startDate);
    this.endDateChange.emit(this.endDate);
  }

  incrementMonth() {
    this.date.setMonth(this.date.getMonth() + 1);
    this.fillCalendar()
  }

  decrementMonth() {
    this.date.setMonth(this.date.getMonth() - 1);
    this.fillCalendar()
  }

  isSameDay(day1: Date | undefined, day2: Date | undefined): boolean {
    if(day1 === undefined || day2 === undefined) {
      return false;
    } else
      return day1.getFullYear() === day2.getFullYear() &&
        day1.getMonth() === day2.getMonth() &&
        day1.getDate() === day2.getDate();
  }

  isBetweenDate(startDate: Date | undefined, endDate: Date | undefined, betweenDate: Date) {
    if(startDate === undefined || endDate === undefined) {
      return false
    } else {
      return betweenDate > startDate && betweenDate < endDate
    }
  }

  protected readonly faChevronLeft = faChevronLeft;
  protected readonly faChevronRight = faChevronRight;
}
